import { action, makeObservable, observable, runInAction } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';

import { ApiGroup, APP_API_TOKEN, IAppApi } from '../../api/app.api';

@injectable()
export class HomePageStore {
    @observable.ref apiGroups: ApiGroup[] = [];
    @observable loading = false;

    constructor(@inject(APP_API_TOKEN) private readonly appApi: IAppApi) {
        makeObservable(this);
    }

    get firstResourceOwnerApiGroup(): ApiGroup | null {
        return this.apiGroups.find(apiGroup => apiGroup.assignedResourceOwners.length > 0) ?? null;
    }

    @action
    async load(): Promise<void> {
        this.loading = true;
        try {
            const config = await this.appApi.getApiConfiguration();
            runInAction(() => {
                this.apiGroups = config.devOnly ? [] : config.apiGroups;
                this.loading = false;
            });
        } catch {
            runInAction(() => {
                this.apiGroups = [];
                this.loading = false;
            });
        }
    }
}
